<template>
  <div class="main-container">
      <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
    <div class="margintop-32" />
    <tl-header type="h1">
      Legacy Salary Data
    </tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="input-label">
      Curabitur scelerisque nisl luctus, porttitor sapien nec, consectetur arcu.</div>
    <div class="mt-19 row" :disabled="!ifTeamleaderAnchorPermission">
      <div class="selectdiv col-2">
        <tl-select
          label="Select Legal Entity"
          :options="legalEntitiesList"
          @change="(val)=>leagalEntityType"
        ></tl-select>
      </div>
    </div>
    <div class="d-month__block d-marginBottom rectangle-month" :disabled="!ifTeamleaderAnchorPermission">
      <div v-for="(monthObj,index) in monthArrayList" :key="index" class="monthItems d-completed">
        <div
          class="monthItems"
          v-bind:class="{'d-completed': (monthObj.status == 'Completed'),'d-pending d-active': (monthObj.status == 'Pending'),'d-upcoming': (monthObj.status == 'Upcoming')}"
        >
          <div class="monthName">{{monthObj.name}} {{monthObj.year}}</div>
          <div class="monthStatus">{{monthObj.status}}</div>
        </div>
      </div>
    </div>
    <div class="mt-19" :disabled="!ifTeamleaderAnchorPermission">
      <download-button></download-button>
    </div>
    <div class="mt-19">
      <upload/>
    </div>
    <div class="mt-19" :disabled="!ifTeamleaderAnchorPermission">
      <btn text="upload Data" type="primary" v-on:click="uploadData"/>
    </div>
  </div>
</template>
<script>
import Upload from "@/components/Upload.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { async } from "q";
export default {
  components: {
    Upload
  },
  computed: {
    ...mapGetters({
      orgid: "onboard/organization/orgid",
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgIds: state => state.id
    }),
    leid() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.legacySalaryValue) {
            return true;
          } else {
            return false;
          }
        }
        // else {
        // return true
        // }
    }
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Payroll",
                url: `/dashboard/${this.$route.params.entity_index}/payroll`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
              },
              {
                name: "Legacy Salary Data",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/legacy_salary_data`
              }
        ],
      month: Date,
      monthArrayList: [],
      legalEntitiesList: ["TeamLease", "Thrymr"],
      monthObj: {},
      leagalEntityType: "",
      uploadFormData: [
        {
          name: "sample",
          le_id: "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a",
          month: "June",
          year: "2019",
          legacydata: {},
          status: "completed"
        },
        {
          name: "sample",
          le_id: "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a",
          month: "June",
          year: "2019",
          legacydata: {},
          status: "completed"
        },
        {
          name: "sample",
          le_id: "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a",
          month: "June",
          year: "2019",
          legacydata: {},
          status: "completed"
        }
      ],
      monthList: [
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        "Jan",
        "Feb",
        "Mar"
      ],
      legacySalaryValue: false,
      role: ""
    };
  },
  activated: function() {
    // with org_id
    this.fetchLegalEntities();
    this.getOrgLeIdList();
  },
  mounted() {
    this.getCurrentMonth();
    //console.log("orgId", this.orgid);
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      fetch: "onboard/legal_entities/fetchAll",
      fetchLegacyData: "dashboard/payroll/utilities/leaves_attendance/fetchLeidData",
      act_create: "dashboard/payroll/utilities/leaves_attendance/create"
    }),
    getCurrentMonth() {
      this.month = new Date().getMonth();
      this.monthArrayList = [];
      //console.log("data", this.monthList[this.month - 3]);
      for (let monthIdx in this.monthList) {
        if (monthIdx < this.month - 3) {
          this.monthObj = {
            name: this.monthList[monthIdx],
            year: new Date().getFullYear(),
            status: "Completed"
          };
        } else if (monthIdx == this.month - 3) {
          this.monthObj = {
            name: this.monthList[monthIdx],
            year: new Date().getFullYear(),
            status: "Pending"
          };
        } else {
          this.monthObj = {
            name: this.monthList[monthIdx],
            year:
              this.monthList[monthIdx] == "Jan" ||
              this.monthList[monthIdx] == "Feb" ||
              this.monthList[monthIdx] == "Mar"
                ? new Date().getFullYear() + 1
                : new Date().getFullYear(),
            status: "Upcoming"
          };
        }
        this.monthArrayList.push(this.monthObj);
      }
      //console.log("monthObj", this.monthArrayList);
    },
    async fetchLegacyDataOfLeid() {
      try {
        (this.le_id = "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a"),
          (this.leaves_data = await this.fetchLegacyData(this.le_id));
        //console.log("fetchAllLeid Data", this.leaves_data);
        this.getCurrentMonth();
      } catch (err) {
        //console.log("intro error", err);
      }
    },
     async uploadData() {
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create({
          data:this.uploadFormData
        })
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        //console.log("error", error);
      }
    },
    async fetchLegalEntities() {
      this.legalEntitiesList = [];
      let legal_entity = {};
      try {
        legal_entity = await this.fetch(this.orgid);
        for (let entity of legal_entity.data) {
          this.legalEntitiesList.push(entity.name);
        }
        //console.log("fetchAll", this.legalEntitiesList);
      } catch (err) {
        //console.log("intro error", err);
        // this.leData=false
      }
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgIds;
        const le = this.leid;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.legacySalaryValue = data.data.user.permissions.legacy_salary ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/components/margins.scss";  //margins
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.component-wrapper {
  margin-left: 14px;
  margin-top: 10px;
}
.d-active {
  background: $color-primary;
  color: $d-color-white;
  .monthStatus {
    display: flex !important;
    padding: 0 25px;
  }
}
.upload {
  grid-row: span 2;
  width: 300px;
  line-height: 7px;
}
.rectangle-month {
  border-radius: 4px;
  margin: 25px 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}

.mt-19 {
  margin-top: 19px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
